import React from 'react';
import styles from './About.module.css';

function About() {
    return (
        <div className={styles.container}>
            {/* Cabeçalho de Destaque */}
            <div className={styles.header}>
                <span className={styles.badge}>Nossa História</span>
                <h2>Transformando a paixão pela criação em gestão inteligente</h2>
                <p>Nascemos do desejo de substituir os velhos cadernos por uma solução moderna, rápida e eficiente para criadores de aves.</p>
            </div>

            {/* Conteúdo Principal / História */}
            <div className={styles.storyCard}>
                <div className={styles.storyText}>
                    <h3>Como tudo começou</h3>
                    <p>
                        A ideia de criar o sistema surgiu a partir de uma visita informal ao criatório de um grande amigo. Ao presenciar a rotina do manejo, ficou evidente a dificuldade e o tempo gasto para buscar informações importantes: para conferir reproduções anteriores, posturas genealogias... era preciso folhear inúmeros cadernos e anotações manuais.
                    </p>
                    <p>
                        Em uma conversa descontraída sobre os desafios da atividade, veio o estalo: <strong>por que não simplificar e digitalizar todo esse processo?</strong>
                    </p>
                    <p>
                        A partir daquele momento, iniciamos o desenvolvimento de uma plataforma pensada por e para criadores, com o objetivo de estar presente em cada etapa do dia a dia do criatório.
                    </p>
                </div>
            </div>

            {/* Seção de Pilares e Funcionalidades do Sistema */}
            <div className={styles.featuresSection}>
                <h3>O que impulsiona o nosso sistema</h3>
                
                <div className={styles.grid}>
                    {/* Pilar 1 */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconBox}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 20h9"></path>
                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                            </svg>
                        </div>
                        <h4>Acompanhamento do Manejo</h4>
                        <p>Ajudamos o criador em todo o processo reprodutivo, desde a postura até o nascimento, eliminando o uso do papel e reduzindo erros de anotação.</p>
                    </div>

                    {/* Pilar 2 */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconBox}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="20" x2="18" y2="10"></line>
                                <line x1="12" y1="20" x2="12" y2="4"></line>
                                <line x1="6" y1="20" x2="6" y2="14"></line>
                            </svg>
                        </div>
                        <h4>Relatórios Estratégicos</h4>
                        <p>Geramos relatórios automatizados de desempenho da reprodução, fertilidade e crescimento para fundamentar suas tomadas de decisão.</p>
                    </div>

                    {/* Pilar 3 */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconBox}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="5" r="3"></circle>
                                <path d="M12 8v4"></path>
                                <circle cx="6" cy="19" r="3"></circle>
                                <circle cx="18" cy="19" r="3"></circle>
                                <path d="M6 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2"></path>
                            </svg>
                        </div>
                        <h4>Árvore Genealógica</h4>
                        <p>Oferecemos o mapa genealógico completo da ave com seu histórico genético, um grande diferencial de valor e transparência na hora da venda.</p>
                    </div>
                </div>
            </div>

            {/* Chamada para Ação */}
            <div className={styles.ctaBox}>
                <h3>Quer modernizar a gestão do seu criatório?</h3>
                <p>Junte-se aos criadores que deixaram os cadernos no passado.</p>
                <a href="/plans" className={styles.ctaBtn}>Conheça nossos planos</a>
            </div>
        </div>
    );
}

export default About;